import "./ReceiptsModal.scss";
import { useState, useEffect } from "react";
import useAuthStore from "../../../../store/authStore";
import { getInvoices } from "../../../../api/stripe/stripe";
import Spinner from "../../../Spinner/Spinner";

function ReceiptsModal({ onClose }) {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = useAuthStore((state) => state.token);

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        setLoading(true);
        const data = await getInvoices(token);
        setInvoices(data.invoices || []);
      } catch (err) {
        console.error("Failed to load invoices:", err);
        setError("Failed to load receipts");
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchInvoices();
    }
  }, [token]);

  const formatDate = (timestamp) => {
    return new Date(timestamp).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const formatCurrency = (amount, currency) => {
    // eslint-disable-next-line no-undef
    return new Intl.NumberFormat("en-DK", {
      style: "currency",
      currency: currency,
    }).format(amount);
  };

  return (
    <div className="receipts-modal-content">
      <div className="title">
        <span>Receipts</span>
        <button className="close-button" onClick={onClose}>
          <span className="material-symbols-outlined">close</span>
        </button>
      </div>

      <div className="main-wrapper">
        {loading ? (
          <div className="receipts-loading">
            <Spinner />
          </div>
        ) : error ? (
          <div className="receipts-error">{error}</div>
        ) : invoices.length === 0 ? (
          <div className="receipts-empty">
            <span className="material-symbols-outlined">receipt_long</span>
            <p>No receipts yet</p>
          </div>
        ) : (
          <div className="receipts-list">
            {invoices.map((invoice) => (
              <a
                key={invoice.id}
                href={invoice.invoicePdf || invoice.hostedInvoiceUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={`receipt-item ${invoice.type === "enterprise" ? "enterprise" : ""}`}
              >
                <div className="receipt-icon">
                  <span className="material-symbols-outlined">
                    {invoice.type === "enterprise" ? "business" : "description"}
                  </span>
                </div>
                <div className="receipt-info">
                  <div className="receipt-name">
                    {invoice.description || invoice.number || "Invoice"}
                    {invoice.type === "enterprise" && (
                      <span className="receipt-badge enterprise">
                        Enterprise
                      </span>
                    )}
                    {invoice.status === "paid" && (
                      <span className="receipt-badge paid">Paid</span>
                    )}
                    {invoice.status === "open" && (
                      <span className="receipt-badge open">Pending</span>
                    )}
                  </div>
                  <div className="receipt-date">
                    {formatDate(invoice.created)}
                  </div>
                </div>
                <div className="receipt-amount">
                  {formatCurrency(invoice.amount, invoice.currency)}
                </div>
                <div className="receipt-action">
                  <span className="material-symbols-outlined">open_in_new</span>
                </div>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ReceiptsModal;
